module.exports = "<span title=\"{{$ctrl.title}}\">{{$ctrl.name | lowercase}}</span>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/employeeName/employeeName.html
// module id = 1005
// module chunks = 0